import * as React from "react"
import styled from "styled-components"
import SatcubeLogo from "../satcube_logo@2x.png"
import { HorizontalSpacer } from "../../components/atoms/spacers"
import { REPORT_SIZE, REPORT_SIZE_SCALING } from "../reports-helpers"
import { ReportSubtitle, ReportTitle } from "../components/ReportText"

export const ReportPage = styled.div`
  width: ${REPORT_SIZE[0] * REPORT_SIZE_SCALING}px;
  height: ${REPORT_SIZE[1] * REPORT_SIZE_SCALING}px;
  background-color: ${({ theme }) => theme.colors.white};
`

const ReportHeader = styled.div`
  background-color: ${({ theme }) => theme.colors.greyDarker};
  padding: ${({ theme }) => theme.spacings.medium};
  padding-inline: 2rem;
  display: flex;
`

const ReportContent = styled.div`
  padding: 2rem;
`

const LogoImg = styled.img`
  height: 16px;
`

const ReportPageTemplate: React.FC<React.PropsWithChildren<{ title?: string; subtitle?: string }>> = ({
  title,
  subtitle,
  children,
}) => {
  return (
    <ReportPage>
      <ReportHeader>
        <LogoImg src={SatcubeLogo} />
      </ReportHeader>
      <ReportContent>
        {title && <ReportTitle>{title}</ReportTitle>}
        {title && subtitle && <HorizontalSpacer spacing={0.25} />}
        {subtitle && <ReportSubtitle>{subtitle}</ReportSubtitle>}
        <HorizontalSpacer spacing={1} />
        {children}
      </ReportContent>
    </ReportPage>
  )
}

export default ReportPageTemplate
